import axios from 'axios';

const educators = {

	getEducators: async (): Promise<TeacherEducatorDTO[]> => {
		return axios.get('/teacher/educators')
			.then(response => response.data as TeacherEducatorDTO[]);
	},
	getEducator: async (educatorId: string): Promise<TeacherEducatorDTO> => {
		return axios.get(`/teacher/educators/${educatorId}`)
			.then(response => response.data as TeacherEducatorDTO);
	},
	getEducatorRoster: async (
		educatorId: string,
		pageIndex: number,
		pageSize: number,
		sortBy: { id: string; desc: boolean } | null,
		searchText: string | undefined,
		filters: Record<string, string[] | number[]>,
		selectedItems: string[]
	): Promise<TeacherStudentRosterDTO> => {
		return axios.get(`/teacher/educators/${educatorId}/roster`, {
			params: {
				PageIndex: pageIndex,
				PageSize: pageSize,
				SortField: sortBy?.id,
				SortOrder: sortBy?.desc ? 'desc' : 'asc',
				SearchText: searchText,
				filters: JSON.stringify(filters),
				selectedItems: JSON.stringify(selectedItems),
			}
		})
			.then(response => response.data as TeacherStudentRosterDTO);
	},

	getEducatorRosterIds: async (
		educatorId: string,
		pageIndex: number,
		pageSize: number,
		sortBy: { id: string; desc: boolean } | null,
		searchText: string | undefined,
		filters: Record<string, string[] | number[]>
	): Promise<TeacherStudentRosterIdsDTO> => {
		return axios.get(`/teacher/educators/${educatorId}/roster/allids`, {
			params: {
				PageIndex: pageIndex,
				PageSize: pageSize,
				SortField: sortBy?.id,
				SortOrder: sortBy?.desc ? 'desc' : 'asc',
				SearchText: searchText,
				filters: JSON.stringify(filters),
			}
		})
			.then(response => response.data as TeacherStudentRosterDTO);
	},
	getUnnasignedStudents: async (
		educatorId: string,
		pageIndex: number,
		pageSize: number,
		sortBy: { id: string; desc: boolean } | null,
		searchText: string | undefined,
		filters: Record<string, string[] | number[]>,
		selectedItems: string[]
	): Promise<TeacherStudentRosterDTO> => {
		return axios.get(`/teacher/educators/${educatorId}/unassignedstudents`, {
			params: {
				PageIndex: pageIndex,
				PageSize: pageSize,
				SortField: sortBy?.id,
				SortOrder: sortBy?.desc ? 'desc' : 'asc',
				SearchText: searchText,
				filters: JSON.stringify(filters),
				selectedItems: JSON.stringify(selectedItems),
			}
		})
			.then(response => response.data as TeacherStudentRosterDTO);
	},
	getUnnasignedStudentsIds: async (
		educatorId: string,
		pageIndex: number,
		pageSize: number,
		sortBy: { id: string; desc: boolean } | null,
		searchText: string | undefined,
		filters: Record<string, string[] | number[]>
	): Promise<TeacherStudentRosterIdsDTO> => {
		return axios.get(`/teacher/educators/${educatorId}/unassignedstudents/allids`, {
			params: {
				PageIndex: pageIndex,
				PageSize: pageSize,
				SortField: sortBy?.id,
				SortOrder: sortBy?.desc ? 'desc' : 'asc',
				SearchText: searchText,
				filters: JSON.stringify(filters),
			}
		})
			.then(response => response.data as TeacherStudentRosterDTO);
	},
	addStudentToEducator: async (educatorRoster: TeacherRosterDTO): Promise<TeacherStudentRosterDTO> => {
		return axios.post('/teacher/educators/add', educatorRoster)
			.then(response => response.data as TeacherStudentRosterDTO);
	},
	removeStudentToEducator: async (educatorRoster: TeacherRosterDTO): Promise<TeacherStudentRosterDTO> => {
		return axios.post('/teacher/educators/remove', educatorRoster)
			.then(response => response.data as TeacherStudentRosterDTO);
	},
	getEducatorSites: async (educatorId: string, sites: string[], type: 'roster' | 'allStudents'): Promise<TeacherSitesDTO> => {
		return axios.get(`/teacher/educators/${educatorId}/sites`, {
			params: {
				SelectedSites: JSON.stringify(sites),
				Type: type
			}
		})
			.then(response => response.data as TeacherSitesDTO);
	},
	worksamplesendtoedi: async (studentId: string | undefined, courseUnitId: string | undefined): Promise<number> => {
		const res = await axios.post('/teacher/worksamplesendtoedi', {
			studentId: studentId,
			courseUnitId: courseUnitId,
		});
		return res.data as number;
	},
};
const schoolAttributeSite = {
	getSchoolSiteList: async (): Promise<SchoolAttributeDTO> => {
		const res = await axios.get(`/teacher/schools/attributes/${AttributeType.Site}`, {});
		return res.data as SchoolAttributeDTO;
	},
	getSchoolSiteById: async (siteId: number): Promise<AttributeItemDTO> => {
		const res = await axios.get(`/teacher/schools/attributes/${AttributeType.Site}/${siteId}`, {});
		return res.data as AttributeItemDTO;
	},
	postSchoolSite: async (siteId: number, siteName: string, siteDescription: string): Promise<SchoolAttributeDTO> => {
		const res = await axios.post(`/teacher/schools/attributes/${AttributeType.Site}`, {
			attributeItemId: siteId,
			value: siteName,
			description: siteDescription,
		});
		return res.data as SchoolAttributeDTO;
	},
	deleteSchoolSite: async (siteId: number): Promise<boolean> => {
		const res = await axios.delete(`/teacher/schools/attributes/${AttributeType.Site}/${siteId}`, {});
		return res.data as boolean;
	},
	getSiteUsersBySiteId: async (siteId: number): Promise<AttributeUsersDTO> => {
		const res = await axios.get(`/teacher/schools/attributes/${AttributeType.Site}/${siteId}/users`, {});
		return res.data as AttributeUsersDTO;
	},
	getUnassignedUsersBySiteId: async (siteId: number): Promise<UserDetailsBase[]> => {
		const res = await axios.get(`/teacher/schools/attributes/${AttributeType.Site}/${siteId}/unassigned-users`, {});
		return res.data as UserDetailsBase[];
	},
	addUsersToSite: async (siteId: number, userIds: number[]): Promise<boolean> => {
		const res = await axios.post(`/teacher/schools/attributes/${AttributeType.Site}/${siteId}/users`, {
			userIds,
		});
		return res.data as boolean;
	},
	removeUserFromSite: async (siteId: number, xrefUserId: number): Promise<boolean> => {
		const res = await axios.delete(`/teacher/schools/attributes/${AttributeType.Site}/${siteId}/users/${xrefUserId}`, {});
		return res.data as boolean;
	},
};

const educatorsApi = {
	educators,
	schoolSites: schoolAttributeSite,
};

const enum AttributeType {
	Site = 'site',
}

export default educatorsApi;